<section id="select-math-operation">
  <div id="sum-fields">
    <div class="equals">=</div>
    <div>
      <mat-button-toggle-group [value]="selectedObjectType1" #group1="matButtonToggleGroup" class="left-aligned"
                               (change)="changeEventFormTypeValue1(group1.value)" hideSingleSelectionIndicator="true">
        <mat-button-toggle [value]="formFieldType1.VALUE" [matTooltip]="'Enter a number'" matTooltipShowDelay="500">
          <span class="material-icons notranslate">numbers</span>
          NUMBER
        </mat-button-toggle>
        <mat-divider [vertical]="true"></mat-divider>
        <mat-button-toggle [value]="formFieldType1.FIELD" [matTooltip]="'Enter a field'" matTooltipShowDelay="500">
          <mat-icon>text_fields</mat-icon>
          FIELD
        </mat-button-toggle>
      </mat-button-toggle-group>
      <div [ngSwitch]="selectedObjectType1" class="other-operators left-aligned">
        <app-paired-autocomplete *ngSwitchCase="formFieldType1.FIELD"
                                 #sourceId1 [selectedFieldControl]="sourceIdControl1"
                                 [secondaryEntityControl]="sourceSecondaryDescriptor1"
                                 [primaryEntity]="primaryEntity"
                                 [componentId]="'math-fieldValue1'"
                                 [entitiesOptions]="entitiesOptions1"
                                 [dataSourceType]="dataSourceType"
                                 [overlayPositioningConfig]="overlayPositioningConfig"
                                 [placeholder]="toManyPlaceholderText1 ? toManyPlaceholderText1 : 'Type to search...'">

        </app-paired-autocomplete>
        <input required *ngSwitchCase="formFieldType1.VALUE" type="number"
               placeholder="Enter a number" min="0" [formControl]="numberInput1">
      </div>
    </div>
    <mat-select id="operators" panelClass="math-operators" [formControl]="selectedOperator"
                (selectionChange)="changeEventOperator($event.value)" placeholder="+">
      <mat-option *ngFor="let o of mathOperators" [value]="o">{{operators[o]}}</mat-option>
    </mat-select>
    <div>
      <mat-button-toggle-group [value]="selectedObjectType2" #group2="matButtonToggleGroup" class="left-aligned"
                               (change)="changeEventFormTypeValue2(group2.value)" hideSingleSelectionIndicator="true">
        <mat-button-toggle [value]="formFieldType2.VALUE" [matTooltip]="'Enter a number'" matTooltipShowDelay="500">
          <span class="material-icons notranslate">numbers</span>
          NUMBER
        </mat-button-toggle>
        <mat-divider [vertical]="true"></mat-divider>
        <mat-button-toggle [value]="formFieldType2.FIELD" [matTooltip]="'Enter a field'" matTooltipShowDelay="500">
          <mat-icon>text_fields</mat-icon>
          FIELD
        </mat-button-toggle>
      </mat-button-toggle-group>
      <div [ngSwitch]="selectedObjectType2" class="other-operators">

        <app-paired-autocomplete *ngSwitchCase="formFieldType2.FIELD"
                          #sourceId2 [selectedFieldControl]="sourceIdControl2"
                          [secondaryEntityControl]="sourceSecondaryDescriptor2"
                          [primaryEntity]="primaryEntity"
                          [componentId]="'math-fieldValue2'"
                          [entitiesOptions]="entitiesOptions2"
                          [dataSourceType]="dataSourceType"
                          [overlayPositioningConfig]="overlayPositioningConfig"
                          [placeholder]="toManyPlaceholderText2 ? toManyPlaceholderText2 : 'Type to search...'">

        </app-paired-autocomplete>
        <input required *ngSwitchCase="formFieldType2.VALUE" type="number"
               placeholder="Enter a number" min="0" [formControl]="numberInput2">
      </div>
      <label id="errormsg" [style.display]="isVisible ? 'block' : 'none'">
        {{errorMessage}}
      </label>
    </div>
  </div>
  <div id="messageResult">
    <label>
      Result: <label [innerHTML]="messageResult"></label>
    </label>
  </div>
  <div id="results">
    <h3 class="heading-underline">Result options</h3>
    <mat-select required [formControl]="selectedRoundType" class="full-width" style="width: 180px"
                (selectionChange)="changeRoundType($event.value)" placeholder="Choose rounding">
      <mat-option *ngFor="let o of roundTypes" [value]="o">{{roundTypesLabels[o]}}</mat-option>
    </mat-select>

    <mat-select id="precision" class="full-width" required [formControl]="valuePrecisionForm" [disabled]="disablePrecision" placeholder="Decimal Places">
      <mat-option  [value]="0">0 (Whole Number)</mat-option>
      <mat-option  [value]="1">1</mat-option>
      <mat-option  [value]="2">2</mat-option>
      <mat-option  [value]="3">3</mat-option>
      <mat-option  [value]="4">4</mat-option>
      <mat-option  [value]="5">5</mat-option>
    </mat-select>
  </div>
</section>


